import * as React from 'react';
import { connect } from 'react-redux';
import { default as DispatchProps, mapDispatchToProps } from '../application/core/DispatchProps';
import UserNotAuthorized from '../application/user/events/UserNotAuthorized';
import { history } from '../application/core/createStore';
import { Redirect } from 'react-router';
import CognitoUserAuthenticator, { UserSessionDetails } from '../application/user/epic/CognitoUserAuthenticator';

const protect = (Component: React.ComponentClass): React.ComponentClass =>
    class extends React.PureComponent<DispatchProps> {
        public render(): JSX.Element | null {
            const currentUser: UserSessionDetails = CognitoUserAuthenticator.currentUserValue;
            if (currentUser.token !== '') {
                return <Component {...this.props} />;
            }
            this.props.dispatch(new UserNotAuthorized(history.location));
            return <Redirect to="/login" />;
        }
    };

export default (Component: React.ComponentClass): React.ComponentClass =>
    connect(
        null,
        mapDispatchToProps
    )(protect(Component));



// WEBPACK FOOTER //
// ./src/view/protect.tsx